import { render, staticRenderFns } from "./MobileTemplateEdit.vue?vue&type=template&id=4a4ceff7&scoped=true"
import script from "./MobileTemplateEdit.vue?vue&type=script&lang=js"
export * from "./MobileTemplateEdit.vue?vue&type=script&lang=js"
import style0 from "./MobileTemplateEdit.vue?vue&type=style&index=0&id=4a4ceff7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a4ceff7",
  null
  
)

export default component.exports